const API_BASE_URL = (import.meta as any).env?.VITE_API_URL || (typeof window !== 'undefined' && window.location?.origin ? '/api' : 'http://localhost:3000/api');

export function getActiveSessionOrganizationCode(): string {
  try {
    const userStr = localStorage.getItem('auth_user');
    if (userStr) {
      const u = JSON.parse(userStr);
      const code = u.organization?.code || u.organization?.id || '';
      if (code === 'XYZ_AIR' || code === 'org_luminix' || code === 'a0000000-0000-0000-0000-000000000001') return 'ORG-XYZ';
      return code || 'ORG-XYZ';
    }
  } catch (e) {}
  return 'ORG-XYZ';
}

export function getActiveSessionUserId(): string {
  try {
    const userStr = localStorage.getItem('auth_user');
    if (userStr) {
      const u = JSON.parse(userStr);
      return u.id || '';
    }
  } catch (e) {}
  return '';
}

export async function apiRequest<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  const cleanEndpoint = endpoint.startsWith('/api/')
    ? endpoint.slice(4)
    : endpoint.startsWith('/')
    ? endpoint
    : `/${endpoint}`;
  const url = `${API_BASE_URL}${cleanEndpoint}`;
  
  // Dynamically resolve organization, user, and role from active session
  const orgId = getActiveSessionOrganizationCode();
  const userId = getActiveSessionUserId();
  let token = '';
  try {
    if (typeof localStorage !== 'undefined') {
      token = localStorage.getItem('auth_token') || '';
    }
  } catch {}

  let userRole = '';
  let userEmail = '';
  let userDepartment = '';
  try {
    const userStr = localStorage.getItem('auth_user');
    if (userStr) {
      const u = JSON.parse(userStr);
      userRole = u.user_type || u.role || '';
      userEmail = u.email || '';
      userDepartment = u.department || '';
    }
  } catch {}

  const dynamicHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) {
    dynamicHeaders['Authorization'] = `Bearer ${token}`;
  }
  if (orgId) {
    dynamicHeaders['x-organization-id'] = orgId;
  }
  if (userId) {
    dynamicHeaders['x-user-id'] = userId;
  }
  if (userRole) {
    dynamicHeaders['x-user-role'] = userRole;
  }
  if (userEmail) {
    dynamicHeaders['x-user-email'] = userEmail;
  }
  if (userDepartment) {
    dynamicHeaders['x-user-department'] = userDepartment;
  }

  const headers = {
    ...dynamicHeaders,
    ...(options.headers || {}),
  };

  const response = await fetch(url, { ...options, headers });
  let data: any;
  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    data = await response.json();
  } else {
    const text = await response.text();
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status} - ${text.slice(0, 150)}`);
    }
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }

  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || `HTTP error! status: ${response.status}`);
  }

  return data.data !== undefined ? data.data : data;
}
